module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bOjH1l/tc-custom/9781646042197.jpg?1729379439493",
      "alt": "This image is the cover for the book Hard Seltzer Cocktail Book"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hard Seltzer Cocktail Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The original cocktail book designed to make your favorite bubbly, boozy beverage that much boozier—includes over fifty sparkling recipes.")]), _c('br'), _c('br'), _vm._v("From sparkling Cosmos and daiquiris to a twist on the ever-popular Aperol spritz, make every season hard seltzer season! The wildly popular sparkling beverage is a tasty, low-cal treat on its own . . . but sometimes you have to take it up a notch (or several). "), _c('i', [_vm._v("The Hard Seltzer Cocktail Book")]), _vm._v(" offers everything you need to add a little snap, sparkle, and pop to your favorite cocktails. Whether you’re team White Claw, a Truly follower, or a Bud Light Seltzer fan, there’s something for everyone with these easy-to-make recipes, including: "), _c('br'), _c('br'), _vm._v("Sparkling Frose * Poppin’ Lemon Drops * Watermelon Sugar Slushies * One-Minute Margs * Summer in Moscow Mules * Fizzy Fuzzy Navels * and more"), _c('br'), _c('br'), _vm._v("These fifty-five recipes are designed to get the party started, whether it’s a Friday night pregame or it's just been a tough day. Instead of that next round of always-regrettable tequila shots, pick up this book—and get bubbly.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Casie Vogel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Casie Vogel is a lover of all things carbonated, whether it's a spiked seltzer happy hour or her daily Diet Coke. She has experience both hosting and attending many a boozy brunch that has transitioned into all-night affairs, thanks to well-mixed drinks. She lives in Brooklyn.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0